import { Injectable } from '@angular/core';
import { NbToastrService } from '@nebular/theme';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  constructor(private toastrService: NbToastrService) {}

  public showToast(message: string, status: string): void {
    this.toastrService.show('', message, { status });
  }
}
